export default __webpack_public_path__ + "static/media/Totem40.bb294379.jpg";